import DE_SUBSCRIPTION_CARD_PAGE_CONSTANTS from './de'
import EN_SUBSCRIPTION_CARD_PAGE_CONSTANTS from './en'
import FR_SUBSCRIPTION_CARD_PAGE_CONSTANTS from './fr'
import HU_SUBSCRIPTION_CARD_PAGE_CONSTANTS from './hu'
import { T_SUBSCRIPTION_CARD_PAGE_CONSTANTS } from './TYPES'

import { T_GENERIC_LANGUAGE_MAP } from '~/src/Constants/LANGUAGE'

import objectPathFactory from '~/src/Lib/objectPathFactory'

const SUBSCRIPTION_CARD_PAGE_CONSTANTS: T_GENERIC_LANGUAGE_MAP<T_SUBSCRIPTION_CARD_PAGE_CONSTANTS> =
  {
    hu: HU_SUBSCRIPTION_CARD_PAGE_CONSTANTS,
    en: EN_SUBSCRIPTION_CARD_PAGE_CONSTANTS,
    fr: FR_SUBSCRIPTION_CARD_PAGE_CONSTANTS,
    de: DE_SUBSCRIPTION_CARD_PAGE_CONSTANTS
  }

export default SUBSCRIPTION_CARD_PAGE_CONSTANTS

export const SUBSCRIPTION_CARD_PAGE_CONSTANTS_PATH =
  objectPathFactory<T_SUBSCRIPTION_CARD_PAGE_CONSTANTS>()
